import dayjs from 'dayjs'
import React, {  useState } from 'react'
import { CreatePaymentParams } from '../../api/payments'
import AsyncButton from '../../components/AsyncButton'
import useAllPayments from '../../data-hooks/useAllPayments'
import useOrganization from '../../data-hooks/useOrganization'
import { getReportingMonth } from '../../utils/dateUtils'

const CURRENT_MONTH = getReportingMonth()
const NEXT_MONTH = getReportingMonth(dayjs().add(1, 'month').toDate())
const PREV_MONTH = getReportingMonth(dayjs().add(-1, 'month').toDate())

export default function CreatePaymentMenu() {
	const [formData, setFormData] = useState<Partial<CreatePaymentParams>>({
		reportingMonth: PREV_MONTH,
		userId: '',
		amount: 0,
		type: 'cash',
		notes: '',
	})

	function changeHandler(e:any) {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		})
	}
	const { organization } = useOrganization()
	const { create } = useAllPayments()
	
	const [message, setMessage] = useState('')
	
	const createHandler = async () => {
		if (formData.reportingMonth && formData.amount && formData.userId && formData.type){
			await create({
				...formData,
				amount: formData.amount * 100,
			} as CreatePaymentParams)
			setMessage('')
		} else {
			setMessage('Fill all required fields!')
		}
	}
	
	return (
		<div className='CreatePaymentMenu formMenu'>
			<div className='story' style={{ color: 'var(--negativeAccentColor)', textAlign: 'center' }}>
				{message}
			</div>
			
			<div className="story">
				<label>Amount</label>
				<input
					type="number"
					className="input wide"
					name='amount'
					value={formData.amount}
					onChange={changeHandler}
					min='0'
				/>
			</div>

			<div className="story">
				<label>Employee</label>
				<select
					className="input wide"
					name='userId'
					value={formData.userId}
					onChange={changeHandler}
				>
					<option value=''></option>
					{organization.members.map((c) => <option value={c.user._id} key={c.user._id}>
						{`${c.user.firstName} ${c.user.lastName}`}
					</option>)}
				</select>
			</div>
			
			<div className="story">
				<label>Type</label>
				<select
					className="input wide"
					name='type'
					value={formData.type}
					onChange={changeHandler}
				>
					<option value='cash'>Cash</option>
					<option value='untracked'>Untracked</option>
					<option value='expense'>Expense</option>
				</select>
			</div>
			
			<div className="story">
				<label>Reporting Month</label>
				<select
					className='wide input'
					name='reportingMonth'
					value={formData.reportingMonth}
					onChange={changeHandler}
				>
					<option value={PREV_MONTH}>{PREV_MONTH}</option>
					<option value={CURRENT_MONTH}>{CURRENT_MONTH}</option>
					<option value={NEXT_MONTH}>{NEXT_MONTH}</option>
				</select>
			</div>

			<div className="story">
				<label>Notes</label>
				<textarea
					className="input wide"
					name='notes'
					value={formData.notes}
					onChange={changeHandler}
					style={{ resize: 'vertical' }}
				/>
			</div>

			<div className="story">
				<AsyncButton
					className="button positive"
					style={{ width: '100%' }}
					onClick={createHandler}
				>
					Create
				</AsyncButton>
			</div>

		</div>
	)
}
